module.exports = __webpack_public_path__ + "img/video_setting-en-US.e07b8ec6.png";